var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect0, _rect1, _rect10, _rect11, _rect12, _path2, _rect13, _rect14, _g, _rect15, _path3, _rect16, _rect17, _rect18, _rect19, _rect20, _path4, _rect21, _rect22, _rect23, _rect24, _rect25, _path5, _rect26, _rect27, _rect28, _rect29, _rect30, _path6, _rect31, _rect32, _rect33, _rect34, _rect35, _path7, _rect36, _rect37, _rect38, _path8, _rect39, _rect40, _rect41, _rect42, _path9, _rect43, _rect44, _rect45, _path0, _rect46, _g2, _rect47, _path1, _rect48, _rect49, _rect50, _path10, _rect51, _rect52, _rect53, _rect54, _path11, _rect55, _rect56, _rect57, _path12, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigninPgImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 950,
    height: 682,
    viewBox: "0 0 950 682",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 949.66,
    height: 681.469,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5556,
    y: 14.495,
    width: 4.25918,
    height: 8.38097,
    rx: 2.12959,
    fill: "url(#paint0_linear_16486_26649)",
    stroke: "url(#paint1_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3792,
    y: 13.1897,
    width: 19.7846,
    height: 7.69401,
    rx: 3.847,
    fill: "url(#paint2_linear_16486_26649)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 928.845,
    y: 16.5559,
    width: 4.25918,
    height: 4.25918,
    rx: 2.12959,
    fill: "url(#paint3_linear_16486_26649)",
    stroke: "url(#paint4_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1895,
    y: 30.776,
    width: 54.4076,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint5_linear_16486_26649)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 143.438,
    y: 64.8495,
    width: 68.1469,
    height: 15.388,
    rx: 1.09914,
    fill: "#EFEFF1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148.934,
    y: 68.1469,
    width: 40.6683,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint6_linear_16486_26649)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 198.395,
    y: 70.8948,
    width: 6.59486,
    height: 3.29743,
    rx: 1.64872,
    fill: "url(#paint7_linear_16486_26649)",
    stroke: "url(#paint8_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1895,
    y: 66.4982,
    width: 117.059,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint9_linear_16486_26649)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1894 107.716C13.1894 107.109 13.6815 106.617 14.2885 106.617H132.682C133.289 106.617 133.781 107.109 133.781 107.716V127.501C133.781 128.108 133.289 128.6 132.682 128.6H14.2885C13.6815 128.6 13.1894 128.108 13.1894 127.501V107.716Z",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7842,
    y: 113.212,
    width: 56.0563,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint10_linear_16486_26649)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7842,
    y: 121.455,
    width: 42.317,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint11_linear_16486_26649)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(118.393 113.212)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 119.492,
    y: 115.959,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint12_linear_16486_26649)",
    stroke: "url(#paint13_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1895,
    y: 93.4272,
    width: 117.059,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint14_linear_16486_26649)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.971 107.716C146.971 107.109 147.463 106.617 148.07 106.617H266.463C267.07 106.617 267.563 107.109 267.563 107.716V127.501C267.563 128.108 267.07 128.6 266.463 128.6H148.07C147.463 128.6 146.971 128.108 146.971 127.501V107.716Z",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 153.566,
    y: 113.212,
    width: 49.4615,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint15_linear_16486_26649)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 153.566,
    y: 122.829,
    width: 57.1555,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint16_linear_16486_26649)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16486_26649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(252.174 113.212)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.273,
    y: 115.959,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint17_linear_16486_26649)",
    stroke: "url(#paint18_linear_16486_26649)",
    strokeWidth: 0.549572
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 146.971,
    y: 93.4272,
    width: 78.5888,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint19_linear_16486_26649)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.752 107.716C280.752 107.109 281.245 106.617 281.852 106.617H400.245C400.852 106.617 401.344 107.109 401.344 107.716V127.501C401.344 128.108 400.852 128.6 400.245 128.6H281.852C281.245 128.6 280.752 128.108 280.752 127.501V107.716Z",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 287.347,
    y: 113.212,
    width: 51.1102,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint20_linear_16486_26649)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 287.347,
    y: 122.829,
    width: 48.9119,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint21_linear_16486_26649)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(385.956 113.212)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 387.055,
    y: 115.959,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint22_linear_16486_26649)",
    stroke: "url(#paint23_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 280.752,
    y: 93.4272,
    width: 81.8862,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint24_linear_16486_26649)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M414.534 107.716C414.534 107.109 415.026 106.617 415.633 106.617H534.026C534.633 106.617 535.126 107.109 535.126 107.716V127.501C535.126 128.108 534.633 128.6 534.026 128.6H415.633C415.026 128.6 414.534 128.108 414.534 127.501V107.716Z",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 421.129,
    y: 113.212,
    width: 46.7136,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint25_linear_16486_26649)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 421.129,
    y: 122.829,
    width: 50.5606,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint26_linear_16486_26649)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(519.738 113.212)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 520.836,
    y: 115.959,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint27_linear_16486_26649)",
    stroke: "url(#paint28_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 414.534,
    y: 93.4272,
    width: 89.0306,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint29_linear_16486_26649)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M548.315 107.716C548.315 107.109 548.807 106.617 549.415 106.617H667.808C668.415 106.617 668.907 107.109 668.907 107.716V127.501C668.907 128.108 668.415 128.6 667.808 128.6H549.415C548.807 128.6 548.315 128.108 548.315 127.501V107.716Z",
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 554.91,
    y: 113.212,
    width: 41.7675,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint30_linear_16486_26649)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 554.91,
    y: 122.829,
    width: 57.1555,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint31_linear_16486_26649)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(653.519 113.212)",
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 654.618,
    y: 115.959,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint32_linear_16486_26649)",
    stroke: "url(#paint33_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 548.315,
    y: 93.4272,
    width: 63.2008,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint34_linear_16486_26649)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M682.097 107.716C682.097 107.109 682.589 106.617 683.196 106.617H801.589C802.197 106.617 802.689 107.109 802.689 107.716V127.501C802.689 128.108 802.197 128.6 801.589 128.6H683.196C682.589 128.6 682.097 128.108 682.097 127.501V107.716Z",
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 688.692,
    y: 113.212,
    width: 40.1187,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint35_linear_16486_26649)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 688.692,
    y: 122.829,
    width: 34.623,
    height: 6.73226,
    rx: 3.36613,
    fill: "url(#paint36_linear_16486_26649)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(787.301 113.212)",
    fill: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 788.399,
    y: 115.959,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint37_linear_16486_26649)",
    stroke: "url(#paint38_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 682.097,
    y: 93.4272,
    width: 111.563,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint39_linear_16486_26649)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M815.878 107.716C815.878 107.109 816.37 106.617 816.978 106.617H935.371C935.978 106.617 936.47 107.109 936.47 107.716V127.501C936.47 128.108 935.978 128.6 935.371 128.6H816.977C816.37 128.6 815.878 128.108 815.878 127.501V107.716Z",
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 818.214,
    y: 128.188,
    width: 115.685,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint40_linear_16486_26649)",
    stroke: "url(#paint41_linear_16486_26649)",
    strokeWidth: 0.274786
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 822.473,
    y: 113.212,
    width: 93.4272,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint42_linear_16486_26649)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 815.878,
    y: 93.4272,
    width: 26.3794,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint43_linear_16486_26649)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1893 149.484C13.1893 148.876 13.6814 148.384 14.2884 148.384H132.682C133.289 148.384 133.781 148.876 133.781 149.484V169.268C133.781 169.875 133.289 170.367 132.682 170.367H14.2884C13.6814 170.367 13.1893 169.875 13.1893 169.268V149.484Z",
    fill: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7841,
    y: 154.979,
    width: 32.9743,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint44_linear_16486_26649)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(118.393 154.979)",
    fill: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 119.492,
    y: 157.727,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint45_linear_16486_26649)",
    stroke: "url(#paint46_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1894,
    y: 135.195,
    width: 86.8324,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint47_linear_16486_26649)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.971 149.483C146.971 148.876 147.463 148.384 148.07 148.384H203.969C204.576 148.384 205.068 148.876 205.068 149.483V169.268C205.068 169.875 204.576 170.367 203.969 170.367H148.07C147.463 170.367 146.971 169.875 146.971 169.268V149.483Z",
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 149.306,
    y: 169.955,
    width: 53.5833,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint48_linear_16486_26649)",
    stroke: "url(#paint49_linear_16486_26649)",
    strokeWidth: 0.274786
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 153.565,
    y: 154.979,
    width: 23.082,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint50_linear_16486_26649)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 146.971,
    y: 135.195,
    width: 20.8837,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint51_linear_16486_26649)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M209.465 149.483C209.465 148.876 209.957 148.384 210.564 148.384H266.463C267.07 148.384 267.562 148.876 267.562 149.483V169.268C267.562 169.875 267.07 170.367 266.463 170.367H210.564C209.957 170.367 209.465 169.875 209.465 169.268V149.483Z",
    fill: "white"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 216.06,
    y: 154.979,
    width: 23.082,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint52_linear_16486_26649)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_16486_26649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(252.174 154.979)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.273,
    y: 157.727,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint53_linear_16486_26649)",
    stroke: "url(#paint54_linear_16486_26649)",
    strokeWidth: 0.549572
  }))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 209.465,
    y: 135.195,
    width: 53.858,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint55_linear_16486_26649)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M280.752 149.483C280.752 148.876 281.244 148.384 281.851 148.384H337.751C338.358 148.384 338.85 148.876 338.85 149.483V169.268C338.85 169.875 338.358 170.367 337.751 170.367H281.851C281.244 170.367 280.752 169.875 280.752 169.268V149.483Z",
    fill: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 283.088,
    y: 169.955,
    width: 53.5833,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint56_linear_16486_26649)",
    stroke: "url(#paint57_linear_16486_26649)",
    strokeWidth: 0.274786
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 287.347,
    y: 154.979,
    width: 37.9205,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint58_linear_16486_26649)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 280.752,
    y: 135.195,
    width: 21.9829,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint59_linear_16486_26649)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M343.246 149.483C343.246 148.876 343.739 148.384 344.346 148.384H400.245C400.852 148.384 401.344 148.876 401.344 149.483V169.268C401.344 169.875 400.852 170.367 400.245 170.367H344.346C343.739 170.367 343.246 169.875 343.246 169.268V149.483Z",
    fill: "white"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 349.841,
    y: 154.979,
    width: 26.3794,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint60_linear_16486_26649)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(385.956 154.979)",
    fill: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 387.055,
    y: 157.727,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint61_linear_16486_26649)",
    stroke: "url(#paint62_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 343.246,
    y: 135.195,
    width: 34.623,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint63_linear_16486_26649)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.534 149.483C414.534 148.876 415.026 148.384 415.633 148.384H534.026C534.633 148.384 535.125 148.876 535.125 149.483V169.268C535.125 169.875 534.633 170.367 534.026 170.367H415.633C415.026 170.367 414.534 169.875 414.534 169.268V149.483Z",
    fill: "white"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 416.869,
    y: 169.955,
    width: 115.685,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint64_linear_16486_26649)",
    stroke: "url(#paint65_linear_16486_26649)",
    strokeWidth: 0.274786
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 421.129,
    y: 154.979,
    width: 91.2289,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint66_linear_16486_26649)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 414.534,
    y: 135.195,
    width: 47.8128,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint67_linear_16486_26649)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M548.315 149.483C548.315 148.876 548.807 148.384 549.414 148.384H667.808C668.415 148.384 668.907 148.876 668.907 149.483V169.268C668.907 169.875 668.415 170.367 667.808 170.367H549.414C548.807 170.367 548.315 169.875 548.315 169.268V149.483Z",
    fill: "white"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 550.651,
    y: 169.955,
    width: 115.685,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint68_linear_16486_26649)",
    stroke: "url(#paint69_linear_16486_26649)",
    strokeWidth: 0.274786
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 554.91,
    y: 154.979,
    width: 81.8862,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint70_linear_16486_26649)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 548.315,
    y: 135.195,
    width: 33.5239,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint71_linear_16486_26649)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 6.59486,
    height: 6.59486,
    transform: "translate(682.097 136.294)",
    fill: "white"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 682.372,
    y: 136.569,
    width: 6.04529,
    height: 6.04529,
    rx: 3.02265,
    fill: "url(#paint72_linear_16486_26649)",
    stroke: "url(#paint73_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 693.088,
    y: 135.195,
    width: 19.7846,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint74_linear_16486_26649)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9826,
    y: 190.152,
    width: 38.47,
    height: 7.69401,
    rx: 3.847,
    fill: "url(#paint75_linear_16486_26649)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 919.983,
    y: 193.999,
    width: 6.59486,
    height: 3.29743,
    rx: 1.64872,
    fill: "url(#paint76_linear_16486_26649)",
    stroke: "url(#paint77_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9825,
    y: 214.333,
    width: 46.7136,
    height: 7.69401,
    rx: 3.847,
    fill: "url(#paint78_linear_16486_26649)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 919.983,
    y: 218.18,
    width: 6.59486,
    height: 3.29743,
    rx: 1.64872,
    fill: "url(#paint79_linear_16486_26649)",
    stroke: "url(#paint80_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 137.942,
    y: 253.902,
    width: 68.1469,
    height: 15.388,
    rx: 1.09914,
    fill: "#EFEFF1"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 143.438,
    y: 257.2,
    width: 34.623,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint81_linear_16486_26649)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 192.899,
    y: 259.947,
    width: 6.59486,
    height: 3.29743,
    rx: 1.64872,
    fill: "url(#paint82_linear_16486_26649)",
    stroke: "url(#paint83_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1895,
    y: 255.551,
    width: 111.563,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint84_linear_16486_26649)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 34.6225,
    y: 292.372,
    width: 1.09914,
    height: 6.59486,
    rx: 0.549572,
    fill: "url(#paint85_linear_16486_26649)",
    stroke: "url(#paint86_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1636,
    y: 289.624,
    width: 79.6879,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint87_linear_16486_26649)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(673.775 291.273)",
    fill: "white"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 674.05,
    y: 291.548,
    width: 8.24358,
    height: 8.24358,
    rx: 4.12179,
    fill: "url(#paint88_linear_16486_26649)",
    stroke: "url(#paint89_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 686.965,
    y: 289.624,
    width: 72.5435,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint90_linear_16486_26649)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 766.378,
    y: 291.548,
    width: 8.24358,
    height: 8.24358,
    rx: 4.12179,
    fill: "url(#paint91_linear_16486_26649)",
    stroke: "url(#paint92_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 786.162,
    y: 291.548,
    width: 8.24358,
    height: 8.24358,
    rx: 4.12179,
    fill: "url(#paint93_linear_16486_26649)",
    stroke: "url(#paint94_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 801.275,
    y: 287.976,
    width: 66.4982,
    height: 15.388,
    rx: 1.09914,
    fill: "#0D6EFD"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 804.573,
    y: 291.273,
    width: 24.1812,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint95_linear_16486_26649)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 856.507,
    y: 291.548,
    width: 7.14443,
    height: 8.24358,
    rx: 3.57222,
    fill: "url(#paint96_linear_16486_26649)",
    stroke: "url(#paint97_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 869.972,
    y: 287.976,
    width: 53.3085,
    height: 15.388,
    rx: 1.09914,
    fill: "#0D6EFD"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 873.269,
    y: 291.273,
    width: 31.3256,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint98_linear_16486_26649)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 911.464,
    y: 291.548,
    width: 8.24358,
    height: 8.24358,
    rx: 4.12179,
    fill: "url(#paint99_linear_16486_26649)",
    stroke: "url(#paint100_linear_16486_26649)",
    strokeWidth: 0.549572
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_16486_26649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3791 309.959C26.3791 309.351 26.8712 308.859 27.4783 308.859H922.181C922.788 308.859 923.28 309.351 923.28 309.959V650.693C923.28 651.3 922.788 651.792 922.181 651.792H27.4782C26.8712 651.792 26.3791 651.3 26.3791 650.693V309.959Z",
    fill: "#7E818D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 896.901,
    height: 20.8837,
    transform: "translate(26.3791 308.859)",
    fill: "#CDCED3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1722,
    y: 313.256,
    width: 29.1273,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint101_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9849,
    y: 313.256,
    width: 53.3085,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint102_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.979,
    y: 313.256,
    width: 57.705,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint103_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.774,
    y: 313.256,
    width: 42.317,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint104_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.57,
    y: 313.256,
    width: 52.2093,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint105_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.366,
    y: 313.256,
    width: 67.5973,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint106_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.739,
    y: 313.256,
    width: 47.2632,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint107_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.739,
    y: 325.621,
    width: 72.5435,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint108_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.112,
    y: 313.256,
    width: 46.7136,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint109_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.33,
    y: 315.179,
    width: 8.24358,
    height: 8.24358,
    rx: 4.12179,
    fill: "url(#paint110_linear_16486_26649)",
    stroke: "url(#paint111_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.16,
    y: 313.256,
    width: 40.1187,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint112_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.16,
    y: 325.621,
    width: 51.6598,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint113_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 726.534,
    y: 313.256,
    width: 41.2179,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint114_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.069,
    y: 313.256,
    width: 45.0649,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint115_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.116,
    y: 313.256,
    width: 30.776,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint116_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.116,
    y: 325.621,
    width: 21.9829,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint117_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 896.901,
    height: 20.8837,
    transform: "translate(26.379 329.743)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1721,
    y: 334.14,
    width: 6.04529,
    height: 8.65576,
    rx: 3.02265,
    fill: "url(#paint118_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9848,
    y: 334.14,
    width: 23.082,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint119_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.979,
    y: 334.14,
    width: 13.7393,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint120_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.774,
    y: 334.14,
    width: 23.082,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint121_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.57,
    y: 334.14,
    width: 13.7393,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint122_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.366,
    y: 334.14,
    width: 45.0649,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint123_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.739,
    y: 334.14,
    width: 41.2179,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint124_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561.112,
    y: 334.14,
    width: 6.04529,
    height: 8.65576,
    rx: 3.02265,
    fill: "url(#paint125_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.16,
    y: 334.14,
    width: 17.5863,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint126_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 726.534,
    y: 334.14,
    width: 19.7846,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint127_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 810.068,
    y: 334.14,
    width: 6.04529,
    height: 8.65576,
    rx: 3.02265,
    fill: "url(#paint128_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 896.901,
    height: 280.282,
    transform: "translate(26.379 350.627)",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5687,
    y: 357.222,
    width: 108.815,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint129_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5686,
    y: 371.511,
    width: 745.769,
    height: 5.7705,
    rx: 2.88525,
    fill: "url(#paint130_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 862.278,
    y: 361.618,
    width: 39.0196,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint131_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5686 407.782C39.5686 407.175 40.0607 406.683 40.6677 406.683H246.208C246.815 406.683 247.307 407.175 247.307 407.782V427.567C247.307 428.174 246.815 428.666 246.208 428.666H40.6677C40.0607 428.666 39.5686 428.174 39.5686 427.567V407.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4382,
    y: 413.553,
    width: 144.537,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint132_linear_16486_26649)",
    stroke: "url(#paint133_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(231.919 413.278)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.017,
    y: 416.025,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint134_linear_16486_26649)",
    stroke: "url(#paint135_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.8434,
    y: 393.768,
    width: 139.591,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint136_linear_16486_26649)",
    stroke: "url(#paint137_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.497 407.782C260.497 407.175 260.989 406.683 261.596 406.683H467.136C467.743 406.683 468.235 407.175 468.235 407.782V427.567C468.235 428.174 467.743 428.666 467.136 428.666H261.596C260.989 428.666 260.497 428.174 260.497 427.567V407.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.832,
    y: 428.254,
    width: 203.067,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint138_linear_16486_26649)",
    stroke: "url(#paint139_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.366,
    y: 413.553,
    width: 102.22,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint140_linear_16486_26649)",
    stroke: "url(#paint141_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.771,
    y: 393.768,
    width: 19.7846,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint142_linear_16486_26649)",
    stroke: "url(#paint143_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.424 407.782C481.424 407.175 481.916 406.683 482.524 406.683H688.063C688.67 406.683 689.163 407.175 689.163 407.782V427.567C689.163 428.174 688.67 428.666 688.063 428.666H482.524C481.916 428.666 481.424 428.174 481.424 427.567V407.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.294,
    y: 413.553,
    width: 142.339,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint144_linear_16486_26649)",
    stroke: "url(#paint145_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(673.775 413.278)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 674.873,
    y: 416.025,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint146_linear_16486_26649)",
    stroke: "url(#paint147_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.699,
    y: 393.768,
    width: 118.158,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint148_linear_16486_26649)",
    stroke: "url(#paint149_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.352 407.782C702.352 407.175 702.844 406.683 703.451 406.683H908.991C909.598 406.683 910.09 407.175 910.09 407.782V427.567C910.09 428.174 909.598 428.666 908.991 428.666H703.451C702.844 428.666 702.352 428.174 702.352 427.567V407.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 704.688,
    y: 428.254,
    width: 203.067,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint150_linear_16486_26649)",
    stroke: "url(#paint151_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.222,
    y: 413.553,
    width: 157.727,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint152_linear_16486_26649)",
    stroke: "url(#paint153_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.627,
    y: 393.768,
    width: 34.0735,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint154_linear_16486_26649)",
    stroke: "url(#paint155_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5686 449.55C39.5686 448.943 40.0607 448.451 40.6677 448.451H98.9224C99.5294 448.451 100.022 448.943 100.022 449.55V469.334C100.022 469.941 99.5294 470.433 98.9224 470.433H40.6677C40.0607 470.433 39.5686 469.941 39.5686 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4382,
    y: 455.32,
    width: 26.3794,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint156_linear_16486_26649)",
    stroke: "url(#paint157_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(84.6335 455.045)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.732,
    y: 457.793,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint158_linear_16486_26649)",
    stroke: "url(#paint159_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.8434,
    y: 435.536,
    width: 41.7675,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint160_linear_16486_26649)",
    stroke: "url(#paint161_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.211 449.55C113.211 448.943 113.703 448.451 114.31 448.451H172.565C173.172 448.451 173.664 448.943 173.664 449.55V469.334C173.664 469.941 173.172 470.433 172.565 470.433H114.31C113.703 470.433 113.211 469.941 113.211 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.081,
    y: 455.32,
    width: 23.082,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint162_linear_16486_26649)",
    stroke: "url(#paint163_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(158.276 455.045)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.375,
    y: 457.793,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint164_linear_16486_26649)",
    stroke: "url(#paint165_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.486,
    y: 435.536,
    width: 38.47,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint166_linear_16486_26649)",
    stroke: "url(#paint167_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.854 449.55C186.854 448.943 187.346 448.451 187.953 448.451H246.208C246.815 448.451 247.307 448.943 247.307 449.55V469.334C247.307 469.941 246.815 470.433 246.208 470.433H187.953C187.346 470.433 186.854 469.941 186.854 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.724,
    y: 455.32,
    width: 22.5324,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint168_linear_16486_26649)",
    stroke: "url(#paint169_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(231.919 455.045)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.018,
    y: 457.793,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint170_linear_16486_26649)",
    stroke: "url(#paint171_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.129,
    y: 435.536,
    width: 58.8042,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint172_linear_16486_26649)",
    stroke: "url(#paint173_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.497 449.55C260.497 448.943 260.989 448.451 261.596 448.451H319.85C320.457 448.451 320.949 448.943 320.949 449.55V469.334C320.949 469.941 320.457 470.433 319.85 470.433H261.596C260.989 470.433 260.497 469.941 260.497 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.366,
    y: 455.32,
    width: 34.0735,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint174_linear_16486_26649)",
    stroke: "url(#paint175_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(305.562 455.045)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.66,
    y: 457.793,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint176_linear_16486_26649)",
    stroke: "url(#paint177_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.771,
    y: 435.536,
    width: 52.2093,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint178_linear_16486_26649)",
    stroke: "url(#paint179_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.139 449.55C334.139 448.943 334.631 448.451 335.238 448.451H393.493C394.1 448.451 394.592 448.943 394.592 449.55V469.334C394.592 469.941 394.1 470.433 393.493 470.433H335.238C334.631 470.433 334.139 469.941 334.139 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.009,
    y: 455.32,
    width: 21.4333,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint180_linear_16486_26649)",
    stroke: "url(#paint181_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_16486_26649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(379.204 455.045)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.303,
    y: 457.793,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint182_linear_16486_26649)",
    stroke: "url(#paint183_linear_16486_26649)",
    strokeWidth: 0.549572
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334.414,
    y: 435.536,
    width: 44.5153,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint184_linear_16486_26649)",
    stroke: "url(#paint185_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.782 449.55C407.782 448.943 408.274 448.451 408.881 448.451H467.136C467.743 448.451 468.235 448.943 468.235 449.55V469.334C468.235 469.941 467.743 470.433 467.136 470.433H408.881C408.274 470.433 407.782 469.941 407.782 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.651,
    y: 455.32,
    width: 19.7846,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint186_linear_16486_26649)",
    stroke: "url(#paint187_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(452.847 455.045)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.945,
    y: 457.793,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint188_linear_16486_26649)",
    stroke: "url(#paint189_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.057,
    y: 435.536,
    width: 44.5153,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint190_linear_16486_26649)",
    stroke: "url(#paint191_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.424 449.55C481.424 448.943 481.916 448.451 482.524 448.451H614.421C615.028 448.451 615.52 448.943 615.52 449.55V469.334C615.52 469.941 615.028 470.433 614.421 470.433H482.524C481.916 470.433 481.424 469.941 481.424 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.76,
    y: 470.021,
    width: 129.424,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint192_linear_16486_26649)",
    stroke: "url(#paint193_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.294,
    y: 455.32,
    width: 74.7418,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint194_linear_16486_26649)",
    stroke: "url(#paint195_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481.699,
    y: 435.536,
    width: 23.082,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint196_linear_16486_26649)",
    stroke: "url(#paint197_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.71 449.55C628.71 448.943 629.202 448.451 629.809 448.451H761.706C762.313 448.451 762.805 448.943 762.805 449.55V469.334C762.805 469.941 762.313 470.433 761.706 470.433H629.809C629.202 470.433 628.71 469.941 628.71 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.045,
    y: 470.021,
    width: 129.424,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint198_linear_16486_26649)",
    stroke: "url(#paint199_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.579,
    y: 455.32,
    width: 65.9486,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint200_linear_16486_26649)",
    stroke: "url(#paint201_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.984,
    y: 435.536,
    width: 30.776,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint202_linear_16486_26649)",
    stroke: "url(#paint203_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.995 449.55C775.995 448.943 776.487 448.451 777.094 448.451H908.991C909.598 448.451 910.09 448.943 910.09 449.55V469.334C910.09 469.941 909.598 470.433 908.991 470.433H777.094C776.487 470.433 775.995 469.941 775.995 469.334V449.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.331,
    y: 470.021,
    width: 129.424,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint204_linear_16486_26649)",
    stroke: "url(#paint205_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.865,
    y: 455.32,
    width: 101.671,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint206_linear_16486_26649)",
    stroke: "url(#paint207_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.27,
    y: 435.536,
    width: 27.4786,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint208_linear_16486_26649)",
    stroke: "url(#paint209_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5686 491.317C39.5686 490.71 40.0607 490.218 40.6677 490.218H98.9224C99.5294 490.218 100.022 490.71 100.022 491.317V511.102C100.022 511.709 99.5294 512.201 98.9224 512.201H40.6677C40.0607 512.201 39.5686 511.709 39.5686 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4382,
    y: 497.088,
    width: 22.5324,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint210_linear_16486_26649)",
    stroke: "url(#paint211_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(84.6335 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.732,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint212_linear_16486_26649)",
    stroke: "url(#paint213_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.8434,
    y: 477.303,
    width: 46.7136,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint214_linear_16486_26649)",
    stroke: "url(#paint215_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.211 491.317C113.211 490.71 113.703 490.218 114.31 490.218H172.565C173.172 490.218 173.664 490.71 173.664 491.317V511.102C173.664 511.709 173.172 512.201 172.565 512.201H114.31C113.703 512.201 113.211 511.709 113.211 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.081,
    y: 497.088,
    width: 31.3256,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint216_linear_16486_26649)",
    stroke: "url(#paint217_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(158.276 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.375,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint218_linear_16486_26649)",
    stroke: "url(#paint219_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.486,
    y: 477.303,
    width: 32.4247,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint220_linear_16486_26649)",
    stroke: "url(#paint221_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.854 491.317C186.854 490.71 187.346 490.218 187.953 490.218H246.208C246.815 490.218 247.307 490.71 247.307 491.317V511.102C247.307 511.709 246.815 512.201 246.208 512.201H187.953C187.346 512.201 186.854 511.709 186.854 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.724,
    y: 497.088,
    width: 36.8213,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint222_linear_16486_26649)",
    stroke: "url(#paint223_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(231.919 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.018,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint224_linear_16486_26649)",
    stroke: "url(#paint225_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.129,
    y: 477.303,
    width: 37.3709,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint226_linear_16486_26649)",
    stroke: "url(#paint227_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.497 491.317C260.497 490.71 260.989 490.218 261.596 490.218H319.85C320.457 490.218 320.949 490.71 320.949 491.317V511.102C320.949 511.709 320.457 512.201 319.85 512.201H261.596C260.989 512.201 260.497 511.709 260.497 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.366,
    y: 497.088,
    width: 26.929,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint228_linear_16486_26649)",
    stroke: "url(#paint229_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(305.562 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.66,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint230_linear_16486_26649)",
    stroke: "url(#paint231_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.771,
    y: 477.303,
    width: 58.8042,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint232_linear_16486_26649)",
    stroke: "url(#paint233_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.139 491.317C334.139 490.71 334.631 490.218 335.238 490.218H393.493C394.1 490.218 394.592 490.71 394.592 491.317V511.102C394.592 511.709 394.1 512.201 393.493 512.201H335.238C334.631 512.201 334.139 511.709 334.139 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.009,
    y: 497.088,
    width: 35.7222,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint234_linear_16486_26649)",
    stroke: "url(#paint235_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_16486_26649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(379.204 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.303,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint236_linear_16486_26649)",
    stroke: "url(#paint237_linear_16486_26649)",
    strokeWidth: 0.549572
  })), /*#__PURE__*/React.createElement("rect", {
    x: 334.414,
    y: 477.303,
    width: 50.011,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint238_linear_16486_26649)",
    stroke: "url(#paint239_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.782 491.317C407.782 490.71 408.274 490.218 408.881 490.218H467.136C467.743 490.218 468.235 490.71 468.235 491.317V511.102C468.235 511.709 467.743 512.201 467.136 512.201H408.881C408.274 512.201 407.782 511.709 407.782 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.651,
    y: 497.088,
    width: 19.235,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint240_linear_16486_26649)",
    stroke: "url(#paint241_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(452.847 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.945,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint242_linear_16486_26649)",
    stroke: "url(#paint243_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.057,
    y: 477.303,
    width: 33.5239,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint244_linear_16486_26649)",
    stroke: "url(#paint245_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.424 491.317C481.424 490.71 481.916 490.218 482.524 490.218H614.421C615.028 490.218 615.52 490.71 615.52 491.317V511.102C615.52 511.709 615.028 512.201 614.421 512.201H482.524C481.916 512.201 481.424 511.709 481.424 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488.294,
    y: 497.088,
    width: 58.8042,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint246_linear_16486_26649)",
    stroke: "url(#paint247_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_16486_26649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(600.132 496.813)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 601.231,
    y: 499.56,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint248_linear_16486_26649)",
    stroke: "url(#paint249_linear_16486_26649)",
    strokeWidth: 0.549572
  })), /*#__PURE__*/React.createElement("rect", {
    x: 481.699,
    y: 477.303,
    width: 112.113,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint250_linear_16486_26649)",
    stroke: "url(#paint251_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.71 491.317C628.71 490.71 629.202 490.218 629.809 490.218H761.706C762.313 490.218 762.805 490.71 762.805 491.317V511.102C762.805 511.709 762.313 512.201 761.706 512.201H629.809C629.202 512.201 628.71 511.709 628.71 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 631.045,
    y: 511.789,
    width: 129.424,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint252_linear_16486_26649)",
    stroke: "url(#paint253_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.579,
    y: 497.088,
    width: 96.7246,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint254_linear_16486_26649)",
    stroke: "url(#paint255_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 628.984,
    y: 477.303,
    width: 21.4333,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint256_linear_16486_26649)",
    stroke: "url(#paint257_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.995 491.317C775.995 490.71 776.487 490.218 777.094 490.218H908.991C909.598 490.218 910.09 490.71 910.09 491.317V511.102C910.09 511.709 909.598 512.201 908.991 512.201H777.094C776.487 512.201 775.995 511.709 775.995 511.102V491.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 778.331,
    y: 511.789,
    width: 129.424,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint258_linear_16486_26649)",
    stroke: "url(#paint259_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 782.865,
    y: 497.088,
    width: 71.4443,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint260_linear_16486_26649)",
    stroke: "url(#paint261_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 776.27,
    y: 477.303,
    width: 41.2179,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint262_linear_16486_26649)",
    stroke: "url(#paint263_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5686 533.085C39.5686 532.478 40.0607 531.986 40.6677 531.986H172.565C173.172 531.986 173.664 532.478 173.664 533.085V552.869C173.664 553.476 173.172 553.968 172.565 553.968H40.6677C40.0607 553.968 39.5686 553.476 39.5686 552.869V533.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.4382,
    y: 538.855,
    width: 43.4162,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint264_linear_16486_26649)",
    stroke: "url(#paint265_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    transform: "translate(158.276 538.58)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.375,
    y: 541.328,
    width: 6.5957,
    height: 3.29841,
    rx: 1.64921,
    fill: "url(#paint266_linear_16486_26649)",
    stroke: "url(#paint267_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.8434,
    y: 519.071,
    width: 123.104,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint268_linear_16486_26649)",
    stroke: "url(#paint269_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.854 533.085C186.854 532.478 187.346 531.986 187.953 531.986H319.85C320.457 531.986 320.949 532.478 320.949 533.085V552.869C320.949 553.476 320.457 553.968 319.85 553.968H187.953C187.346 553.968 186.854 553.476 186.854 552.869V533.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.19,
    y: 553.556,
    width: 129.424,
    height: 0.274786,
    rx: 0.137393,
    fill: "url(#paint270_linear_16486_26649)",
    stroke: "url(#paint271_linear_16486_26649)",
    strokeWidth: 0.274786
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.724,
    y: 538.855,
    width: 92.8776,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint272_linear_16486_26649)",
    stroke: "url(#paint273_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.129,
    y: 519.071,
    width: 12.0906,
    height: 5.22093,
    rx: 2.61047,
    fill: "url(#paint274_linear_16486_26649)",
    stroke: "url(#paint275_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5686,
    y: 580.348,
    width: 88.4811,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint276_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.645,
    y: 580.348,
    width: 36.8213,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint277_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.551,
    y: 600.957,
    width: 8.24358,
    height: 8.24358,
    rx: 4.12179,
    fill: "url(#paint278_linear_16486_26649)",
    stroke: "url(#paint279_linear_16486_26649)",
    strokeWidth: 0.549572
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.257,
    y: 599.033,
    width: 36.8213,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint280_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.5686,
    y: 599.033,
    width: 73.0931,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint281_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 896.901,
    height: 20.8837,
    transform: "translate(26.379 630.908)",
    fill: "#EFEFF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.1721,
    y: 635.305,
    width: 6.04529,
    height: 8.65576,
    rx: 3.02265,
    fill: "url(#paint282_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.9848,
    y: 635.305,
    width: 23.082,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint283_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.483,
    y: 635.305,
    width: 30.776,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint284_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.279,
    y: 635.305,
    width: 22.5324,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint285_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.074,
    y: 635.305,
    width: 30.776,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint286_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.87,
    y: 635.305,
    width: 45.0649,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint287_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.075,
    y: 635.305,
    width: 41.2179,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint288_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.28,
    y: 635.305,
    width: 14.2889,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint289_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.328,
    y: 635.305,
    width: 17.5863,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint290_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 726.534,
    y: 635.305,
    width: 6.04529,
    height: 8.65576,
    rx: 3.02265,
    fill: "url(#paint291_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 793.581,
    y: 635.305,
    width: 14.2889,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint292_linear_16486_26649)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 879.864,
    y: 635.305,
    width: 34.623,
    height: 8.65576,
    rx: 4.32788,
    fill: "url(#paint293_linear_16486_26649)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16486_26649",
    x1: 21.0896,
    y1: 18.7638,
    x2: 16.2808,
    y2: 18.7638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16486_26649",
    x1: 21.0896,
    y1: 18.7638,
    x2: 16.2808,
    y2: 18.7638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16486_26649",
    x1: 46.1638,
    y1: 17.1042,
    x2: 26.3792,
    y2: 17.1042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16486_26649",
    x1: 933.379,
    y1: 18.7276,
    x2: 928.57,
    y2: 18.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16486_26649",
    x1: 933.379,
    y1: 18.7276,
    x2: 928.57,
    y2: 18.7276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16486_26649",
    x1: 67.5971,
    y1: 35.1798,
    x2: 13.1895,
    y2: 35.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16486_26649",
    x1: 189.602,
    y1: 71.0828,
    x2: 148.934,
    y2: 71.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16486_26649",
    x1: 205.265,
    y1: 72.5772,
    x2: 198.12,
    y2: 72.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16486_26649",
    x1: 205.265,
    y1: 72.5772,
    x2: 198.12,
    y2: 72.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16486_26649",
    x1: 130.248,
    y1: 70.902,
    x2: 13.1895,
    y2: 70.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16486_26649",
    x1: 75.8405,
    y1: 116.148,
    x2: 19.7842,
    y2: 116.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16486_26649",
    x1: 62.1012,
    y1: 124.391,
    x2: 19.7842,
    y2: 124.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16486_26649",
    x1: 126.362,
    y1: 117.642,
    x2: 119.217,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_16486_26649",
    x1: 126.362,
    y1: 117.642,
    x2: 119.217,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_16486_26649",
    x1: 130.248,
    y1: 96.3631,
    x2: 13.1895,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_16486_26649",
    x1: 203.027,
    y1: 116.637,
    x2: 153.566,
    y2: 116.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_16486_26649",
    x1: 210.721,
    y1: 126.254,
    x2: 153.566,
    y2: 126.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_16486_26649",
    x1: 260.144,
    y1: 117.642,
    x2: 252.998,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_16486_26649",
    x1: 260.144,
    y1: 117.642,
    x2: 252.998,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_16486_26649",
    x1: 225.56,
    y1: 96.3631,
    x2: 146.971,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_16486_26649",
    x1: 338.458,
    y1: 116.637,
    x2: 287.347,
    y2: 116.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_16486_26649",
    x1: 336.259,
    y1: 126.254,
    x2: 287.347,
    y2: 126.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_16486_26649",
    x1: 393.925,
    y1: 117.642,
    x2: 386.78,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_16486_26649",
    x1: 393.925,
    y1: 117.642,
    x2: 386.78,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_16486_26649",
    x1: 362.639,
    y1: 96.3631,
    x2: 280.752,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_16486_26649",
    x1: 467.842,
    y1: 116.637,
    x2: 421.129,
    y2: 116.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_16486_26649",
    x1: 471.689,
    y1: 126.254,
    x2: 421.129,
    y2: 126.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_16486_26649",
    x1: 527.707,
    y1: 117.642,
    x2: 520.561,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_16486_26649",
    x1: 527.707,
    y1: 117.642,
    x2: 520.561,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_16486_26649",
    x1: 503.564,
    y1: 96.3631,
    x2: 414.534,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_16486_26649",
    x1: 596.678,
    y1: 116.637,
    x2: 554.91,
    y2: 116.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_16486_26649",
    x1: 612.066,
    y1: 126.254,
    x2: 554.91,
    y2: 126.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_16486_26649",
    x1: 661.488,
    y1: 117.642,
    x2: 654.343,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_16486_26649",
    x1: 661.488,
    y1: 117.642,
    x2: 654.343,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_16486_26649",
    x1: 611.516,
    y1: 96.3631,
    x2: 548.315,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_16486_26649",
    x1: 728.81,
    y1: 116.637,
    x2: 688.692,
    y2: 116.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_16486_26649",
    x1: 723.315,
    y1: 126.254,
    x2: 688.692,
    y2: 126.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_16486_26649",
    x1: 795.27,
    y1: 117.642,
    x2: 788.124,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_16486_26649",
    x1: 795.27,
    y1: 117.642,
    x2: 788.124,
    y2: 117.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_16486_26649",
    x1: 793.66,
    y1: 96.3631,
    x2: 682.097,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_16486_26649",
    x1: 934.036,
    y1: 128.33,
    x2: 818.077,
    y2: 128.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_16486_26649",
    x1: 934.036,
    y1: 128.33,
    x2: 818.077,
    y2: 128.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_16486_26649",
    x1: 915.9,
    y1: 116.148,
    x2: 822.473,
    y2: 116.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_16486_26649",
    x1: 842.258,
    y1: 96.3631,
    x2: 815.878,
    y2: 96.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_16486_26649",
    x1: 52.7584,
    y1: 157.915,
    x2: 19.7841,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_16486_26649",
    x1: 126.362,
    y1: 159.41,
    x2: 119.217,
    y2: 159.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_16486_26649",
    x1: 126.362,
    y1: 159.41,
    x2: 119.217,
    y2: 159.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_16486_26649",
    x1: 100.022,
    y1: 138.131,
    x2: 13.1894,
    y2: 138.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_16486_26649",
    x1: 203.027,
    y1: 170.097,
    x2: 149.169,
    y2: 170.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_16486_26649",
    x1: 203.027,
    y1: 170.097,
    x2: 149.169,
    y2: 170.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_16486_26649",
    x1: 176.647,
    y1: 157.915,
    x2: 153.565,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_16486_26649",
    x1: 167.855,
    y1: 138.131,
    x2: 146.971,
    y2: 138.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_16486_26649",
    x1: 239.142,
    y1: 157.915,
    x2: 216.06,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_16486_26649",
    x1: 260.144,
    y1: 159.41,
    x2: 252.998,
    y2: 159.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_16486_26649",
    x1: 260.144,
    y1: 159.41,
    x2: 252.998,
    y2: 159.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_16486_26649",
    x1: 263.323,
    y1: 138.13,
    x2: 209.465,
    y2: 138.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_16486_26649",
    x1: 336.809,
    y1: 170.097,
    x2: 282.951,
    y2: 170.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_16486_26649",
    x1: 336.809,
    y1: 170.097,
    x2: 282.951,
    y2: 170.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_16486_26649",
    x1: 325.268,
    y1: 157.915,
    x2: 287.347,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_16486_26649",
    x1: 302.735,
    y1: 138.131,
    x2: 280.752,
    y2: 138.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_16486_26649",
    x1: 376.221,
    y1: 157.915,
    x2: 349.841,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_16486_26649",
    x1: 393.925,
    y1: 159.41,
    x2: 386.78,
    y2: 159.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_16486_26649",
    x1: 393.925,
    y1: 159.41,
    x2: 386.78,
    y2: 159.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_16486_26649",
    x1: 377.869,
    y1: 138.13,
    x2: 343.246,
    y2: 138.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_16486_26649",
    x1: 532.692,
    y1: 170.097,
    x2: 416.732,
    y2: 170.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_16486_26649",
    x1: 532.692,
    y1: 170.097,
    x2: 416.732,
    y2: 170.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_16486_26649",
    x1: 512.357,
    y1: 157.915,
    x2: 421.129,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_16486_26649",
    x1: 462.346,
    y1: 138.131,
    x2: 414.534,
    y2: 138.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_16486_26649",
    x1: 666.473,
    y1: 170.097,
    x2: 550.513,
    y2: 170.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_16486_26649",
    x1: 666.473,
    y1: 170.097,
    x2: 550.513,
    y2: 170.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_16486_26649",
    x1: 636.796,
    y1: 157.915,
    x2: 554.91,
    y2: 157.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_16486_26649",
    x1: 581.839,
    y1: 138.131,
    x2: 548.315,
    y2: 138.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_16486_26649",
    x1: 688.692,
    y1: 139.649,
    x2: 682.097,
    y2: 139.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_16486_26649",
    x1: 688.692,
    y1: 139.649,
    x2: 682.097,
    y2: 139.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_16486_26649",
    x1: 712.873,
    y1: 138.13,
    x2: 693.088,
    y2: 138.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_16486_26649",
    x1: 60.4526,
    y1: 194.066,
    x2: 21.9826,
    y2: 194.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_16486_26649",
    x1: 926.853,
    y1: 195.681,
    x2: 919.708,
    y2: 195.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_16486_26649",
    x1: 926.853,
    y1: 195.681,
    x2: 919.708,
    y2: 195.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_16486_26649",
    x1: 68.6961,
    y1: 218.248,
    x2: 21.9825,
    y2: 218.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_16486_26649",
    x1: 926.853,
    y1: 219.862,
    x2: 919.708,
    y2: 219.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_16486_26649",
    x1: 926.853,
    y1: 219.862,
    x2: 919.708,
    y2: 219.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_16486_26649",
    x1: 178.061,
    y1: 260.135,
    x2: 143.438,
    y2: 260.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_16486_26649",
    x1: 199.769,
    y1: 261.63,
    x2: 192.625,
    y2: 261.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_16486_26649",
    x1: 199.769,
    y1: 261.63,
    x2: 192.625,
    y2: 261.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_16486_26649",
    x1: 124.753,
    y1: 259.955,
    x2: 13.1895,
    y2: 259.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_16486_26649",
    x1: 35.9965,
    y1: 295.732,
    x2: 34.3477,
    y2: 295.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_16486_26649",
    x1: 35.9965,
    y1: 295.732,
    x2: 34.3477,
    y2: 295.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_16486_26649",
    x1: 125.851,
    y1: 294.028,
    x2: 46.1636,
    y2: 294.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_16486_26649",
    x1: 682.568,
    y1: 295.747,
    x2: 673.775,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_16486_26649",
    x1: 682.568,
    y1: 295.747,
    x2: 673.775,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_16486_26649",
    x1: 759.508,
    y1: 294.028,
    x2: 686.965,
    y2: 294.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_16486_26649",
    x1: 774.896,
    y1: 295.747,
    x2: 766.103,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_16486_26649",
    x1: 774.896,
    y1: 295.747,
    x2: 766.103,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_16486_26649",
    x1: 794.681,
    y1: 295.747,
    x2: 785.887,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_16486_26649",
    x1: 794.681,
    y1: 295.747,
    x2: 785.887,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_16486_26649",
    x1: 828.754,
    y1: 294.209,
    x2: 804.573,
    y2: 294.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_16486_26649",
    x1: 863.927,
    y1: 295.747,
    x2: 856.233,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_16486_26649",
    x1: 863.927,
    y1: 295.747,
    x2: 856.233,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_16486_26649",
    x1: 904.595,
    y1: 294.209,
    x2: 873.269,
    y2: 294.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_16486_26649",
    x1: 919.983,
    y1: 295.747,
    x2: 911.19,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_16486_26649",
    x1: 919.983,
    y1: 295.747,
    x2: 911.19,
    y2: 295.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_16486_26649",
    x1: 64.2995,
    y1: 317.66,
    x2: 35.1722,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_16486_26649",
    x1: 136.293,
    y1: 317.66,
    x2: 82.9849,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_16486_26649",
    x1: 212.684,
    y1: 317.66,
    x2: 154.979,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_16486_26649",
    x1: 267.091,
    y1: 317.66,
    x2: 224.774,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_16486_26649",
    x1: 346.779,
    y1: 317.66,
    x2: 294.57,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_16486_26649",
    x1: 431.963,
    y1: 317.66,
    x2: 364.366,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_16486_26649",
    x1: 510.002,
    y1: 317.66,
    x2: 462.739,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_16486_26649",
    x1: 535.283,
    y1: 330.025,
    x2: 462.739,
    y2: 330.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_16486_26649",
    x1: 607.826,
    y1: 317.66,
    x2: 561.112,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_16486_26649",
    x1: 707.848,
    y1: 319.378,
    x2: 699.055,
    y2: 319.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_16486_26649",
    x1: 707.848,
    y1: 319.378,
    x2: 699.055,
    y2: 319.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_16486_26649",
    x1: 668.279,
    y1: 317.66,
    x2: 628.16,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_16486_26649",
    x1: 679.82,
    y1: 330.025,
    x2: 628.16,
    y2: 330.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_16486_26649",
    x1: 767.752,
    y1: 317.66,
    x2: 726.534,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_16486_26649",
    x1: 855.133,
    y1: 317.66,
    x2: 810.069,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_16486_26649",
    x1: 907.892,
    y1: 317.66,
    x2: 877.116,
    y2: 317.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_16486_26649",
    x1: 899.099,
    y1: 330.025,
    x2: 877.116,
    y2: 330.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_16486_26649",
    x1: 41.2174,
    y1: 338.544,
    x2: 35.1721,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_16486_26649",
    x1: 106.067,
    y1: 338.544,
    x2: 82.9848,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_16486_26649",
    x1: 168.718,
    y1: 338.544,
    x2: 154.979,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_16486_26649",
    x1: 247.856,
    y1: 338.544,
    x2: 224.774,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_16486_26649",
    x1: 308.309,
    y1: 338.544,
    x2: 294.57,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_16486_26649",
    x1: 409.431,
    y1: 338.544,
    x2: 364.366,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_16486_26649",
    x1: 503.957,
    y1: 338.544,
    x2: 462.739,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_16486_26649",
    x1: 567.158,
    y1: 338.544,
    x2: 561.112,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_16486_26649",
    x1: 645.746,
    y1: 338.544,
    x2: 628.16,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_16486_26649",
    x1: 746.318,
    y1: 338.544,
    x2: 726.534,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_16486_26649",
    x1: 816.114,
    y1: 338.544,
    x2: 810.068,
    y2: 338.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_16486_26649",
    x1: 148.384,
    y1: 361.625,
    x2: 39.5687,
    y2: 361.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_16486_26649",
    x1: 785.338,
    y1: 374.446,
    x2: 39.5687,
    y2: 374.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_16486_26649",
    x1: 901.297,
    y1: 366.022,
    x2: 862.278,
    y2: 366.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_16486_26649",
    x1: 191.25,
    y1: 416.214,
    x2: 46.1634,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_16486_26649",
    x1: 191.25,
    y1: 416.214,
    x2: 46.1634,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_16486_26649",
    x1: 239.888,
    y1: 417.708,
    x2: 232.743,
    y2: 417.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_16486_26649",
    x1: 239.888,
    y1: 417.708,
    x2: 232.743,
    y2: 417.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_16486_26649",
    x1: 179.709,
    y1: 396.429,
    x2: 39.5687,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_16486_26649",
    x1: 179.709,
    y1: 396.429,
    x2: 39.5687,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_16486_26649",
    x1: 466.037,
    y1: 428.396,
    x2: 262.695,
    y2: 428.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_16486_26649",
    x1: 466.037,
    y1: 428.396,
    x2: 262.695,
    y2: 428.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_16486_26649",
    x1: 369.861,
    y1: 416.214,
    x2: 267.092,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_16486_26649",
    x1: 369.861,
    y1: 416.214,
    x2: 267.092,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_16486_26649",
    x1: 280.831,
    y1: 396.429,
    x2: 260.496,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_16486_26649",
    x1: 280.831,
    y1: 396.429,
    x2: 260.496,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_16486_26649",
    x1: 630.908,
    y1: 416.214,
    x2: 488.019,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_16486_26649",
    x1: 630.908,
    y1: 416.214,
    x2: 488.019,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_16486_26649",
    x1: 681.744,
    y1: 417.708,
    x2: 674.598,
    y2: 417.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_16486_26649",
    x1: 681.744,
    y1: 417.708,
    x2: 674.598,
    y2: 417.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_16486_26649",
    x1: 600.132,
    y1: 396.429,
    x2: 481.424,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_16486_26649",
    x1: 600.132,
    y1: 396.429,
    x2: 481.424,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_16486_26649",
    x1: 907.892,
    y1: 428.396,
    x2: 704.551,
    y2: 428.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_16486_26649",
    x1: 907.892,
    y1: 428.396,
    x2: 704.551,
    y2: 428.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_16486_26649",
    x1: 867.224,
    y1: 416.214,
    x2: 708.947,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_16486_26649",
    x1: 867.224,
    y1: 416.214,
    x2: 708.947,
    y2: 416.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_16486_26649",
    x1: 736.975,
    y1: 396.429,
    x2: 702.352,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_16486_26649",
    x1: 736.975,
    y1: 396.429,
    x2: 702.352,
    y2: 396.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_16486_26649",
    x1: 73.0924,
    y1: 457.981,
    x2: 46.1634,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_16486_26649",
    x1: 73.0924,
    y1: 457.981,
    x2: 46.1634,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_16486_26649",
    x1: 92.6025,
    y1: 459.476,
    x2: 85.4572,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_16486_26649",
    x1: 92.6025,
    y1: 459.476,
    x2: 85.4572,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_16486_26649",
    x1: 81.8857,
    y1: 438.197,
    x2: 39.5686,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_16486_26649",
    x1: 81.8857,
    y1: 438.197,
    x2: 39.5686,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_16486_26649",
    x1: 143.438,
    y1: 457.981,
    x2: 119.806,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_16486_26649",
    x1: 143.438,
    y1: 457.981,
    x2: 119.806,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_16486_26649",
    x1: 166.245,
    y1: 459.476,
    x2: 159.1,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_16486_26649",
    x1: 166.245,
    y1: 459.476,
    x2: 159.1,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_16486_26649",
    x1: 152.231,
    y1: 438.197,
    x2: 113.211,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_16486_26649",
    x1: 152.231,
    y1: 438.197,
    x2: 113.211,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_16486_26649",
    x1: 216.531,
    y1: 457.981,
    x2: 193.449,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_16486_26649",
    x1: 216.531,
    y1: 457.981,
    x2: 193.449,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_16486_26649",
    x1: 239.888,
    y1: 459.476,
    x2: 232.743,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_16486_26649",
    x1: 239.888,
    y1: 459.476,
    x2: 232.743,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_16486_26649",
    x1: 246.208,
    y1: 438.197,
    x2: 186.854,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_16486_26649",
    x1: 246.208,
    y1: 438.197,
    x2: 186.854,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_16486_26649",
    x1: 301.715,
    y1: 457.981,
    x2: 267.092,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_16486_26649",
    x1: 301.715,
    y1: 457.981,
    x2: 267.092,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_16486_26649",
    x1: 313.531,
    y1: 459.476,
    x2: 306.386,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_16486_26649",
    x1: 313.531,
    y1: 459.476,
    x2: 306.386,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_16486_26649",
    x1: 313.255,
    y1: 438.197,
    x2: 260.496,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_16486_26649",
    x1: 313.255,
    y1: 438.197,
    x2: 260.496,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_16486_26649",
    x1: 362.717,
    y1: 457.981,
    x2: 340.734,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_16486_26649",
    x1: 362.717,
    y1: 457.981,
    x2: 340.734,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_16486_26649",
    x1: 387.173,
    y1: 459.476,
    x2: 380.028,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_16486_26649",
    x1: 387.173,
    y1: 459.476,
    x2: 380.028,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_16486_26649",
    x1: 379.204,
    y1: 438.197,
    x2: 334.139,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_16486_26649",
    x1: 379.204,
    y1: 438.197,
    x2: 334.139,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_16486_26649",
    x1: 434.711,
    y1: 457.981,
    x2: 414.377,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_16486_26649",
    x1: 434.711,
    y1: 457.981,
    x2: 414.377,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_16486_26649",
    x1: 460.816,
    y1: 459.476,
    x2: 453.671,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_16486_26649",
    x1: 460.816,
    y1: 459.476,
    x2: 453.671,
    y2: 459.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_16486_26649",
    x1: 452.847,
    y1: 438.197,
    x2: 407.782,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_16486_26649",
    x1: 452.847,
    y1: 438.197,
    x2: 407.782,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_16486_26649",
    x1: 613.322,
    y1: 470.164,
    x2: 483.623,
    y2: 470.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_16486_26649",
    x1: 613.322,
    y1: 470.164,
    x2: 483.623,
    y2: 470.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_16486_26649",
    x1: 563.311,
    y1: 457.981,
    x2: 488.019,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_16486_26649",
    x1: 563.311,
    y1: 457.981,
    x2: 488.019,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_16486_26649",
    x1: 505.056,
    y1: 438.197,
    x2: 481.424,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_16486_26649",
    x1: 505.056,
    y1: 438.197,
    x2: 481.424,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_16486_26649",
    x1: 760.607,
    y1: 470.164,
    x2: 630.908,
    y2: 470.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_16486_26649",
    x1: 760.607,
    y1: 470.164,
    x2: 630.908,
    y2: 470.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_16486_26649",
    x1: 701.803,
    y1: 457.981,
    x2: 635.305,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_16486_26649",
    x1: 701.803,
    y1: 457.981,
    x2: 635.305,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_16486_26649",
    x1: 660.035,
    y1: 438.197,
    x2: 628.71,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_16486_26649",
    x1: 660.035,
    y1: 438.197,
    x2: 628.71,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_16486_26649",
    x1: 907.892,
    y1: 470.164,
    x2: 778.193,
    y2: 470.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_16486_26649",
    x1: 907.892,
    y1: 470.164,
    x2: 778.193,
    y2: 470.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_16486_26649",
    x1: 884.81,
    y1: 457.981,
    x2: 782.59,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_16486_26649",
    x1: 884.81,
    y1: 457.981,
    x2: 782.59,
    y2: 457.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_16486_26649",
    x1: 804.023,
    y1: 438.197,
    x2: 775.995,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_16486_26649",
    x1: 804.023,
    y1: 438.197,
    x2: 775.995,
    y2: 438.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_16486_26649",
    x1: 69.2454,
    y1: 499.749,
    x2: 46.1634,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_16486_26649",
    x1: 69.2454,
    y1: 499.749,
    x2: 46.1634,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_16486_26649",
    x1: 92.6025,
    y1: 501.243,
    x2: 85.4572,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_16486_26649",
    x1: 92.6025,
    y1: 501.243,
    x2: 85.4572,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_16486_26649",
    x1: 86.8318,
    y1: 479.964,
    x2: 39.5686,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_16486_26649",
    x1: 86.8318,
    y1: 479.964,
    x2: 39.5686,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_16486_26649",
    x1: 151.681,
    y1: 499.749,
    x2: 119.806,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_16486_26649",
    x1: 151.681,
    y1: 499.749,
    x2: 119.806,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_16486_26649",
    x1: 166.245,
    y1: 501.243,
    x2: 159.1,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_16486_26649",
    x1: 166.245,
    y1: 501.243,
    x2: 159.1,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_16486_26649",
    x1: 146.186,
    y1: 479.964,
    x2: 113.211,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_16486_26649",
    x1: 146.186,
    y1: 479.964,
    x2: 113.211,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_16486_26649",
    x1: 230.82,
    y1: 499.749,
    x2: 193.449,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_16486_26649",
    x1: 230.82,
    y1: 499.749,
    x2: 193.449,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_16486_26649",
    x1: 239.888,
    y1: 501.243,
    x2: 232.743,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_16486_26649",
    x1: 239.888,
    y1: 501.243,
    x2: 232.743,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_16486_26649",
    x1: 224.774,
    y1: 479.964,
    x2: 186.854,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_16486_26649",
    x1: 224.774,
    y1: 479.964,
    x2: 186.854,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_16486_26649",
    x1: 294.57,
    y1: 499.749,
    x2: 267.092,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_16486_26649",
    x1: 294.57,
    y1: 499.749,
    x2: 267.092,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_16486_26649",
    x1: 313.531,
    y1: 501.243,
    x2: 306.386,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_16486_26649",
    x1: 313.531,
    y1: 501.243,
    x2: 306.386,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_16486_26649",
    x1: 319.85,
    y1: 479.964,
    x2: 260.496,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_16486_26649",
    x1: 319.85,
    y1: 479.964,
    x2: 260.496,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_16486_26649",
    x1: 377.006,
    y1: 499.749,
    x2: 340.734,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_16486_26649",
    x1: 377.006,
    y1: 499.749,
    x2: 340.734,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_16486_26649",
    x1: 387.173,
    y1: 501.243,
    x2: 380.028,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_16486_26649",
    x1: 387.173,
    y1: 501.243,
    x2: 380.028,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_16486_26649",
    x1: 384.7,
    y1: 479.964,
    x2: 334.139,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_16486_26649",
    x1: 384.7,
    y1: 479.964,
    x2: 334.139,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_16486_26649",
    x1: 434.161,
    y1: 499.749,
    x2: 414.377,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_16486_26649",
    x1: 434.161,
    y1: 499.749,
    x2: 414.377,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_16486_26649",
    x1: 460.816,
    y1: 501.243,
    x2: 453.671,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_16486_26649",
    x1: 460.816,
    y1: 501.243,
    x2: 453.671,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_16486_26649",
    x1: 441.855,
    y1: 479.964,
    x2: 407.782,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_16486_26649",
    x1: 441.855,
    y1: 479.964,
    x2: 407.782,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_16486_26649",
    x1: 547.373,
    y1: 499.749,
    x2: 488.019,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_16486_26649",
    x1: 547.373,
    y1: 499.749,
    x2: 488.019,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_16486_26649",
    x1: 608.101,
    y1: 501.243,
    x2: 600.956,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_16486_26649",
    x1: 608.101,
    y1: 501.243,
    x2: 600.956,
    y2: 501.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_16486_26649",
    x1: 594.087,
    y1: 479.964,
    x2: 481.424,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_16486_26649",
    x1: 594.087,
    y1: 479.964,
    x2: 481.424,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_16486_26649",
    x1: 760.607,
    y1: 511.931,
    x2: 630.908,
    y2: 511.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_16486_26649",
    x1: 760.607,
    y1: 511.931,
    x2: 630.908,
    y2: 511.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_16486_26649",
    x1: 732.579,
    y1: 499.749,
    x2: 635.305,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_16486_26649",
    x1: 732.579,
    y1: 499.749,
    x2: 635.305,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_16486_26649",
    x1: 650.693,
    y1: 479.964,
    x2: 628.71,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_16486_26649",
    x1: 650.693,
    y1: 479.964,
    x2: 628.71,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_16486_26649",
    x1: 907.892,
    y1: 511.931,
    x2: 778.193,
    y2: 511.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_16486_26649",
    x1: 907.892,
    y1: 511.931,
    x2: 778.193,
    y2: 511.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_16486_26649",
    x1: 854.584,
    y1: 499.749,
    x2: 782.59,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_16486_26649",
    x1: 854.584,
    y1: 499.749,
    x2: 782.59,
    y2: 499.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_16486_26649",
    x1: 817.762,
    y1: 479.964,
    x2: 775.995,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_16486_26649",
    x1: 817.762,
    y1: 479.964,
    x2: 775.995,
    y2: 479.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_16486_26649",
    x1: 90.1292,
    y1: 541.516,
    x2: 46.1634,
    y2: 541.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_16486_26649",
    x1: 90.1292,
    y1: 541.516,
    x2: 46.1634,
    y2: 541.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_16486_26649",
    x1: 166.245,
    y1: 543.011,
    x2: 159.1,
    y2: 543.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_16486_26649",
    x1: 166.245,
    y1: 543.011,
    x2: 159.1,
    y2: 543.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_16486_26649",
    x1: 163.222,
    y1: 521.732,
    x2: 39.5687,
    y2: 521.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_16486_26649",
    x1: 163.222,
    y1: 521.732,
    x2: 39.5687,
    y2: 521.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_16486_26649",
    x1: 318.751,
    y1: 553.698,
    x2: 189.052,
    y2: 553.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_16486_26649",
    x1: 318.751,
    y1: 553.698,
    x2: 189.052,
    y2: 553.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_16486_26649",
    x1: 286.876,
    y1: 541.516,
    x2: 193.449,
    y2: 541.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_16486_26649",
    x1: 286.876,
    y1: 541.516,
    x2: 193.449,
    y2: 541.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_16486_26649",
    x1: 199.494,
    y1: 521.732,
    x2: 186.854,
    y2: 521.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_16486_26649",
    x1: 199.494,
    y1: 521.732,
    x2: 186.854,
    y2: 521.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_16486_26649",
    x1: 128.05,
    y1: 584.752,
    x2: 39.5686,
    y2: 584.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_16486_26649",
    x1: 171.466,
    y1: 584.752,
    x2: 134.645,
    y2: 584.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_16486_26649",
    x1: 167.069,
    y1: 605.156,
    x2: 158.276,
    y2: 605.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_16486_26649",
    x1: 167.069,
    y1: 605.156,
    x2: 158.276,
    y2: 605.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_16486_26649",
    x1: 156.078,
    y1: 603.437,
    x2: 119.257,
    y2: 603.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_16486_26649",
    x1: 112.662,
    y1: 603.437,
    x2: 39.5686,
    y2: 603.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_16486_26649",
    x1: 41.2174,
    y1: 639.709,
    x2: 35.1721,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_16486_26649",
    x1: 106.067,
    y1: 639.709,
    x2: 82.9848,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_16486_26649",
    x1: 180.259,
    y1: 639.709,
    x2: 149.483,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_16486_26649",
    x1: 241.811,
    y1: 639.709,
    x2: 219.279,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_16486_26649",
    x1: 319.85,
    y1: 639.709,
    x2: 289.074,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_16486_26649",
    x1: 403.935,
    y1: 639.709,
    x2: 358.87,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_16486_26649",
    x1: 500.293,
    y1: 639.709,
    x2: 459.075,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_16486_26649",
    x1: 573.569,
    y1: 639.709,
    x2: 559.28,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_16486_26649",
    x1: 643.914,
    y1: 639.709,
    x2: 626.328,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_16486_26649",
    x1: 732.579,
    y1: 639.709,
    x2: 726.534,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_16486_26649",
    x1: 807.87,
    y1: 639.709,
    x2: 793.581,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_16486_26649",
    x1: 914.487,
    y1: 639.709,
    x2: 879.864,
    y2: 639.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16486_26649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    fill: "white",
    transform: "translate(252.174 113.212)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_16486_26649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    fill: "white",
    transform: "translate(252.174 154.979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_16486_26649"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3791 309.959C26.3791 309.351 26.8712 308.859 27.4783 308.859H922.181C922.788 308.859 923.28 309.351 923.28 309.959V650.693C923.28 651.3 922.788 651.792 922.181 651.792H27.4782C26.8712 651.792 26.3791 651.3 26.3791 650.693V309.959Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_16486_26649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    fill: "white",
    transform: "translate(379.204 455.045)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_16486_26649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    fill: "white",
    transform: "translate(379.204 496.813)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_16486_26649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.79315,
    height: 8.79315,
    fill: "white",
    transform: "translate(600.132 496.813)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninPgImg);
export default __webpack_public_path__ + "static/media/signin-pg-img.c8e281cf3745887393cd23032c38f669.svg";
export { ForwardRef as ReactComponent };